"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contractTypeOptions = void 0;
exports.contractTypeOptions = new Set([
    { text: 'Lump Sum', value: 'LUMP_SUM' },
    { text: 'Cost Plus', value: 'COST_PLUS' },
    { text: 'Design-Build', value: 'DESIGN_BUILD' },
    { text: 'IPD', value: 'IPD' },
    { text: 'Time and Materials', value: 'TIME_AND_MATERIALS' },
    { text: 'Unit Price', value: 'UNIT_PRICE' },
    { text: 'Incentive', value: 'INCENTIVE' },
    { text: 'GMP', value: 'GMP' },
]);
